import React, { useCallback, useMemo } from 'react';
import Form from '@/common/components/Form/index';
import styles from '@/common/containers/Forms/DecedentResidence/styles.less';
import { TextInput } from '@/common/components/Inputs/index';
import * as yup from 'yup';
import { capitalize } from '@mui/material';
import { useTranslation } from 'react-i18next';

const DecedentResidence = ({
  className,
  initialValues = {},
  onSubmit,
  hideBlockLabel = false,
  formId,
  ...props
}) => {
  const { t } = useTranslation();
  const validation = useMemo(
    () =>
      yup.object({
        residenceAddressLine1: yup
          .string()
          .trim()
          .required(t('Please enter address line 1')),
        residenceAddressLine2: yup.string().trim(),
        residenceCountry: yup
          .string()
          .trim()
          .required(t('Please enter country')),
        residenceCity: yup.string().trim().required(t('Please enter city')),
        residenceProvince: yup
          .string()
          .trim()
          .required(t('Please enter province')),
        residencePostalCode: yup.string().trim(),
      }),
    [t]
  );
  const form = useMemo(() => {
    return [
      {
        name: 'residenceAddressLine1',
        label: t('Address line 1'),
        required: true,
      },
      {
        name: 'residenceAddressLine2',
        label: t('Address line 2'),
      },
      {
        name: 'residenceCity',
        label: t('City'),
        required: true,
        onChangeFormat: (value) => capitalize(value),
      },
      {
        name: 'residenceProvince',
        label: t('Province / State'),
        required: true,
        disabled: true,
        onChangeFormat: (value) => capitalize(value),
      },
      {
        name: 'residenceCountry',
        label: t('Country'),
        required: true,
        disabled: true,
        onChangeFormat: (value) => capitalize(value),
      },
      {
        name: 'residencePostalCode',
        label: t('Postal code'),
        mask: 'a0a 0a0',
        placeholder: t('A0A 0A0'),
      },
    ];
  }, [t]);

  const renderInputs = useCallback(
    (form) =>
      form.map((input) => (
        <TextInput
          key={input.name}
          className={styles.blockBodyRowItem}
          {...input}
        />
      )),
    []
  );

  const INITIALS = useMemo(
    () => ({
      ...initialValues,
      residenceCountry: 'Canada',
      residenceProvince: 'Ontario',
    }),
    [initialValues]
  );
  return (
    <Form
      className={className}
      validation={validation}
      initialValues={INITIALS}
      onSubmit={onSubmit}
      id={formId}
      {...props}
    >
      <div className={styles.block}>
        {!hideBlockLabel && (
          <div className={styles.blockHeader}>
            {t('Legal residence at time of death')}
          </div>
        )}
        <div className={styles.blockBody}>
          <div className={styles.blockBodyRow}>
            {renderInputs(form.slice(0, 2))}
          </div>
          <div className={styles.blockBodyRow}>
            {renderInputs(form.slice(2, 6))}
          </div>
        </div>
      </div>
    </Form>
  );
};

export default DecedentResidence;
